<template>
  <v-card class="mx-auto mt-5 card--shadow">
    <v-toolbar elevation="0" color="purple accent-4" dark>
      <v-toolbar-title>Feedbacks</v-toolbar-title>
    </v-toolbar>
    <div class="feedback-input-container">
      <v-textarea
        v-model="comment"
        placeholder="type here..."
        clearable
        filled
        auto-grow
        rows="2"
        row-height="30"
        :error-messages="handleFieldErrors($v.comment)"
      />
      <div class="d-flex justify-end">
        <v-btn @click.prevent="createComment" class="form-btn">
          <v-icon left>mdi-chevron-right-circle-outline</v-icon>Submit
        </v-btn>
      </div>
    </div>
    <v-divider v-if="feedbacks.length != 0" />
    <v-list>
      <template v-for="(item, index) in feedbacks">
        <v-list-item :key="item.feedback">
          <template>
            <v-list-item-content>
              <v-list-item-action-text
                class="text--primary feedback-text"
                v-text="item.body"
              ></v-list-item-action-text>

              <v-list-item-subtitle>
                {{ item.author.name }}

                <span
                  v-if="+item.done === 0 && item.author_type === 'ADMIN'"
                  class="mx-3 red--text font-weight-bold"
                  >Not Done</span
                >
                <span
                  v-else-if="+item.done === 1 && item.author_type === 'ADMIN'"
                  class="mx-3 green--text font-weight-bold"
                  >Done</span
                >
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                >{{ displayDateFormat(item.created_at) }}
                <v-btn
                  v-if="item.author_type === 'ADMIN'"
                  @click="deleteComment(item.id)"
                  icon
                  color="pink"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action-text>
            </v-list-item-action>
          </template>
        </v-list-item>

        <v-divider v-if="index < feedbacks.length - 1" :key="index"></v-divider>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import { ValidationMixin } from "../../mixins/ValidationMixin";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [ValidationMixin],

  props: {
    authorId: { type: Number },
    feedbacks: {
      type: Array,
    },
  },
  data: () => ({
    comment: "",
  }),
  validations() {
    return {
      comment: { required },
    };
  },

  methods: {
    displayDateFormat(date) {
      return new Date(date).toLocaleDateString("en-us", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    },
    createComment() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit("createComment", this.comment);
        this.comment = "";
      }
    },
    deleteComment(id) {
      this.$emit("deleteComment", id);
    },
  },
};
</script>
